"use strict";

var create = function create(metadata, exports) {
  return {
    metadata: metadata,
    exports: exports
  };
};

module.exports = create;


//////////////////
// WEBPACK FOOTER
// ./~/graylog-web-plugin/lib/PluginManifest.js
// module id = 178
// module chunks = 0